
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "brandManage",
})

export default class brandManage extends Vue {
	
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    
	this.getbrandManageList(1);
  }
  
  private getbrandManageList(num: number){
	  
	  let datas = [];
	  this.pageNo = num;
	  	let pageNum = this.pageNo;
	  	let pageSize = 10;
	  let enable = 1;
	  // let type = 3;
	    let paramter = {
	  		pageNum,
	  		pageSize,
	  		enable,
	    // type
	    };
	    this.$http.get("brand/share/list", {paramter}).then((res: any) => {
	    	datas = res.data.data.data;
			this.pageNo = num;
			this.pageSize = res.data.data.pageSize;
	    	this.tableData = datas;
	  		this.tableData = this.tableData.map(item=>{
	  			
	  			let logoDatas = [];
	  			logoDatas.push(item.logo);
	  			item.logoDatas = logoDatas;
	  			item.enable = item.enable == 1?true:false;
	  			return item;
	  		});
	  		
	    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	
	this.getbrandManageList(this.pageNo);
  }

  private onSubmit() {
    console.log(this.form);
  }
  private addSubmit() {
    console.log(this.form);
    this.$router.push('/Brand/addBrand')
  }

  private userStateChange(item) {

    // 是否启用
    console.log(item);
  }
  private handleUpdate(index, row){
    // 编辑品牌
	this.$router.push({path: '/Brand/editBrand',query:{cid:row.id,cname:row.name,clogo:row.logo}})
  }
  private handleDelete(index, row){
    // 删除品牌
    console.log(row);
	// 删除类型
	this.$http.delete("/brand/delete/"+row.id,{}).then((res: any) =>{
		
		this.$message({
		    message: '删除成功',
		    type: 'success'
		});
		window.location.reload();
		this.dialogVisible = false;
	});
  }
}
